<template>
  <div class="bottom-menu-container">
    <van-tabbar route>
      <van-tabbar-item replace to="/host" icon="home-o">
        <span>{{ $t('tabbar.hosting') }}</span>
        <template #icon>
          <img :src="$route.path.indexOf('/host') != -1 ? require('../../assets/home-selected.svg') : require('../../assets/home-select.svg')" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-if="configInfo.is_loan" replace to="/loan" icon="home-o">
        <span>{{ $t('loan_title') }}</span>
        <template #icon>
          <img :src="$route.path.indexOf('/loan') != -1 ? require('../../assets/loan-selected.svg') : require('../../assets/loan-select.svg')" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/user" icon="search">
        <span>{{ $t('tabbar.account') }}</span>
        <template #icon>
          <img :src="$route.path.indexOf('/user') != -1 ? require('../../assets/wallet-selected.svg') : require('../../assets/wallet-select.svg')" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      configInfo: ''
    };
  },
  created() {
    this.getConfig()
  },
  methods: {
    async getConfig() {
      const res = await this.$api.getConfig()
      if(res.code == 200) {
        this.configInfo = res.data
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-menu-container {
  width: 100%;
  position: fixed;
  bottom: 0;
}
@media (min-width: 640px) {
  .bottom-menu-container {
    max-width: 540px;
  }
  /deep/ .van-tabbar {
    position: relative;
    height: 80px;
  }
  /deep/ .van-tabbar-item {
    font-size: 12px;
  }
  /deep/ .van-tabbar-item__icon {
    font-size: 16px;
  }
  /deep/ .van-tabbar-item__icon img {
    height: 40px;
  }
}
</style>